module.exports = __webpack_public_path__ + "static/parking-match-71ea4fb49b7b6af42829a73eb155ce4e.png";